<body class="flex flex-col min-h-screen">
  <header class="bg-white shadow">
    <div class="hidden lg:block">
      <div class="px-5 h-16 flex justify-between items-center">
        <a [routerLink]="['/']">
          <img ngSrc="assets/2kolela.png" width="300" height="40" alt="Logo" class="mr-2" priority />
        </a>
        <div class="flex gap-2 items-center">
          @if (isLoading()) {
          <p-skeleton width="250px" height="35px"></p-skeleton>
          } @else if (isLoggedIn()) {
          <div
            class="relative inline-block group hover:bg-primaryActive p-3 rounded-lg text-userActionButton hover:text-white">
            <ng-container *ngIf="userProfile(); else loadingAvatar">
              <div class="flex items-center space-x-2">
                @let profileImage = userProfile()?.profile_image;
                @if(profileImage){
                <div class="h-10 w-10">
                  <p-avatar [image]="profileImage" class="mr-2" size="normal" shape="circle"
                    class="border-2 border-primaryActive" />
                </div>
                }@else {
                <div class="rounded-full overflow-hidden h-10 w-10 border-2 border-primaryActive">
                  <img [src]="
                      userProfile()!.first_name
                        | avatar : userProfile()!.last_name
                    " alt="User Avatar" class="h-10 w-10 object-cover" />
                </div>
                }
                <span class="font-bold text-base">Моят профил</span>
              </div>
            </ng-container>

            <ng-template #loadingAvatar>
              <p-skeleton width="40px" height="40px"></p-skeleton>
            </ng-template>
            <div
              class="absolute left-0 z-50 mt-[4px] w-[173px] rounded-b-lg bg-primaryActive shadow-lg hidden group-hover:block transition-all duration-200">
              <ul class="cursor-pointer text-base">
                <li>
                  <a [routerLink]="['user','my-listings']" class="block px-4 py-2 hover:bg-green-700">
                    Моите обяви
                  </a>
                </li>
                <li>
                  <a [routerLink]="['user','profile']" class="block px-4 py-2 hover:bg-green-700 hover:rounded-b-lg">
                    Настройки
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <span class="border-r border-gray-500 h-5"></span>
          <button class="font-bold text-base text-userActionButton" (click)="onLogout()">
            Изход
          </button>
          } @else {
          <a [routerLink]="['/auth/login']" class="text-primary font-bold font-inter">
            Вход
          </a>
          <div class="w-px h-[35px] bg-[#147E3A] mx-[15px]"></div>
          <a [routerLink]="['/auth/register']" class="text-primary font-bold font-inter">
            Нова регистрация
          </a>
          }
        </div>
      </div>

      <nav class="bg-primary">
        <div class="flex items-center">
          @for (category of categories(); track category.id) {
          <a [routerLink]="[category.slug]" routerLinkActive="!bg-primaryActive" class="nav-button"
            [routerLinkActiveOptions]="{ exact: true }">
            {{ category.name.toLocaleUpperCase() }}
          </a>
          }
          <a routerLink="search" routerLinkActive="!bg-primaryActive" class="nav-button uppercase">
            Разширено търсене
          </a>
          <a routerLink="/listing/create">
            <p-button label="+ ДОБАВИ ОБЯВА" severity="secondary" class="ml-6" />
          </a>
        </div>
      </nav>
    </div>

    <div class="lg:hidden flex items-center bg-white h-[60px] px-4 justify-between">
      <button class="text-primary" (click)="drawerVisible = true">
        <i class="pi pi-bars !text-xl"></i>
      </button>
      <a [routerLink]="['/']"><img src="assets/na2kolela-small-img.png" alt="Logo" class="h-10" /></a>
      <a routerLink="/listing/create">
        <button class="text-primary text-4xl font-bold">
          +
        </button>
      </a>
    </div>
  </header>

  <p-drawer [(visible)]="drawerVisible" #drawerRef header="Меню">
    <div class="space-y-2 mt-6 text-lg">
      @for (category of categories(); track category.id) {
      <a [routerLink]="[category.slug]" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }" class="block text-gray-700 py-1 pl-4">
        {{ category.name }}
      </a>
      }
      <a [routerLink]="['/search']" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }" class="block text-gray-700 py-1 pl-4 uppercase">
        Разширено търсене
      </a>
      <a [routerLink]="['/listing/create']" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }" class="block py-1 text-primary font-bold cursor-pointer pl-4">
        + Добави обява
      </a>
      @if (isLoggedIn()) {
      <a [routerLink]="['/user/my-listings']" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }" class="block py-1 cursor-pointer pl-4">
        Моите обяви
      </a>
      <a [routerLink]="['/user/profile']" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }" class="block py-1 cursor-pointer pl-4">
        Настройки
      </a>
      <button (click)="onLogout()" class="block py-1 text-left cursor-pointer pl-4">
        Изход
      </button>
      } @else {
      <a [routerLink]="['/auth/login']" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }"
        class="block w-full text-left py-1 text-primary font-bold cursor-pointer pl-4">
        Вход
      </a>
      <a [routerLink]="['/auth/register']" routerLinkActive="bg-lightGreen text-white"
        [routerLinkActiveOptions]="{ exact: true }"
        class="block w-full text-left py-1 text-primary font-bold cursor-pointer pl-4">
        Нова регистрация
      </a>
      }
    </div>
  </p-drawer>

  <main class="flex-grow">
    <router-outlet></router-outlet>
  </main>

  <footer class="footer pb-5">
    <hr class="border border-lightGreen" />

    <div class="px-12">
      <div class="pt-3 text-gray-700 text-sm flex flex-wrap">
        <span class="font-bold text-gray font-inter mr-3 mt-1">
          Основни категории в na2kolela.bg:
        </span>
        <div class="flex flex-wrap space-x-4">
          @for(category of categories(); track category.id) {
          <a [routerLink]="[category.slug]" class="text-gray text-base mb-2 underline">
            {{ category.name }}
          </a>
          }
        </div>
      </div>
    </div>

    <div class="flex flex-wrap justify-start gap-4 py-4 font-bold text-black px-12">
      <a [routerLink]="['contact']" class="footer-links">
        КОНТАКТИ
      </a>
      <div class="w-px h-[19px] mt-1 bg-black"></div>
      <a [routerLink]="['terms-and-conditions']" class="terms-and-conditions">
        ОБЩИ УСЛОВИЯ
      </a>
    </div>

    <div class="h-[42px] text-lightGreen text-xl font-bold flex items-center justify-start px-12">
      2025 ® Copyright na2kolela
    </div>
  </footer>
</body>